import { initializeApp } from "firebase/app";

const firebaseConfig = {
  // databaseURL: '<your-database-url>',
  apiKey: "AIzaSyB8AkyvbySDSpCnHo8UXejbb1Xxb2d07pg",
  authDomain: "klasha-system.firebaseapp.com",
  projectId: "klasha-system",
  storageBucket: "klasha-system.appspot.com",
};

const firebaseApp: any = initializeApp(firebaseConfig);

// // Get a reference to the storage service, which is used to create references in your storage bucket
// const firebaseStorage = getStorage(firebaseApp);

export default firebaseApp;
